import { Box, Flex } from "@mantine/core";
import { useRole } from "../../redux/features/user";
import PageTitle from "../../components/Page/PageTitle";
import PageWrapper from "../../components/Page/PageWrapper";
import ActionsPanel from "./actionsPanel/actionsPanel";
import EmailNotifications from "./emailNotifications/EmailNotifications";
import EmailSettings from "./emailSettings/EmailSettings.jsx";
import GeneralSettings from "./generalSettings/GeneralSettings";
import RoleEmailNotifications from "./roleEmailNotifications/RoleEmailNotifications";
import { useTranslation } from "react-i18next";

export default function Settings() {
  const role = useRole();
  const isAdminOrGrantAdmin = role === "GRANT_ADMIN" || role === "ADMIN";
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <Box pb="xl">
        <PageTitle title={t("pageHeaders.settings")} />
        <GeneralSettings />
        <Flex gap="md" align="flex-start" mt="md">
          <Box style={{ flex: 1 }}>
            <Flex direction="column" gap="md">
              {isAdminOrGrantAdmin && <ActionsPanel />}
              <EmailNotifications />
            </Flex>
          </Box>
          {isAdminOrGrantAdmin && (
            <Box style={{ flex: 1 }}>
              <EmailSettings />
            </Box>
          )}
        </Flex>
        {isAdminOrGrantAdmin && (
          <Box mt="md">
            <RoleEmailNotifications />
          </Box>
        )}
      </Box>
    </PageWrapper>
  );
}
